import { metadata } from "./metadata.js";
import component from "./index.vue";

export default { metadata, component };
